export default __webpack_public_path__ + "static/media/acososexual.8ecde541.png";